import React, { useEffect, useState } from "react";
import Header from "../../../components/Events/Header/Header";
import EventCard from "../../../components/Events/EventCard";
import { events as initialEvents } from "../../../misc/constants";
import EventsTable from "../../../components/Events/EventsTable/EventsTable";
import AddEventCard from "../../../components/Events/AddEvent/AddEventCard";
import { simpleGetter } from "../../../actions/common";
import { mainApi } from "../../../api/api";

export default function Events() {
  const [openEventId, setOpenEventId] = useState(null);
  const [events, setEvents] = useState(initialEvents);
  const [filteredEvents, setFilteredEvents] = useState(initialEvents);
  const [isAddingEvent, setIsAddingEvent] = useState(false);

  const test = async () => {
    simpleGetter(mainApi.getDepartments)
  }

  useEffect(() => {
    test()
  }, [])

  const handleAddEvent = (newEvent) => {
    const updatedEvents = [...events, newEvent];
    setEvents(updatedEvents);

    if (filteredEvents !== events) {
      const updatedFilteredEvents = filteredEvents.filter((event) =>
        event.title.toLowerCase().includes(newEvent.title.toLowerCase())
      );
      setFilteredEvents(updatedFilteredEvents);
    } else {
      setFilteredEvents(updatedEvents);
    }
  };

  return (
    <div className="p-4 rounded-xl m-8 flex gap-4">
      <div
        className={`bg-white transition-all duration-100 ease-in-out rounded-xl ${openEventId ? "w-[40%]" : "w-full"
          }`}
      >
        <Header
          openEventId={openEventId}
          setFilteredEvents={setFilteredEvents}
          setIsAddingEvent={setIsAddingEvent}
          isAddingEvent={isAddingEvent}
          filteredEvents={filteredEvents}
          events={events}
        />
        <EventsTable
          openEventId={openEventId}
          setOpenEventId={setOpenEventId}
          filteredEvents={filteredEvents}
          setFilteredEvents={setFilteredEvents}
          isAddingEvent={isAddingEvent}
          setEvents={setEvents}
        />
      </div>

      {isAddingEvent && (
        <AddEventCard
          onAddEvent={handleAddEvent}
          onClose={() => setIsAddingEvent(false)}
        />
      )}

      {openEventId && (
        <div className="rounded-lg">
          <EventCard
            event={filteredEvents.find((event) => event.id === openEventId)}
            close={() => setOpenEventId(null)}
          />
        </div>
      )}
    </div>
  );
}
